import React from 'react';
import { createRoot } from 'react-dom/client'; 
import PwaInstallPromptLoader from './PwaInstallPromptLoader';
//import ReactDOM from 'react-dom';
import { HashRouter,withRouter } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import queryString from 'query-string';
//app
import './main.css';
import App from "flexbiz-core"
import facebook from 'flexbiz-core/components/social/facebook';
import google from 'flexbiz-core/components/social/google';
//import config from "./config.cjs";
const config = window.appConfig; 
const {facebook_page_id,facebook_app_id,facebook_greeting,mainColor,GOOGLE_RECAPTCHA_SITE_KEY,USE_HASH_ROUTER} = config;
import Provider from "./apps/erp/components/Provider";
import NotifyProvider from "./apps/erp/components/NotifyProvider";
import routes from "./apps/erp/routes.js";
config.routes = routes;
//disabled all console info
console.info = function() {}
class ClientApp extends React.PureComponent{
  constructor(props){
    super(props);
    //get query params
    let queryParams={};
    if(typeof window !== 'undefined'){
      if(!config.id_app) config.id_app  = localStorage.getItem("id_app");
      config.home_url = window.location.href;
      queryParams = queryString.parse(window.location.search);
      let ps = (window.location.href.split("#/"));
      if(ps.length>1){
        let localHref = ps[1];
        if(localHref.indexOf("?")>=0){
          const params2 = queryString.parse(localHref.split("?")[1]);
          queryParams = {...params2,...queryParams};
        }
      }
      //queryParams.multi_lang = queryParams.multi_lang||queryParams.for_agent==1;
      config.queryParams = queryParams;
      //id_app
      if( queryParams.id_app=="undefined"){
        delete queryParams.id_app
      }

      let _id_app = queryParams.id_app;
      if(_id_app){
        config.id_app = config.default_id_app = _id_app;
        localStorage.setItem("id_app",_id_app);
        config.id_app_dynamic = false;
        //group user default
        let _group_id = queryParams.user_group_id;
        if(_group_id){
          config.group_id = _group_id;
        }
      }
      //name_app
      if(queryParams.app_name){
        config.app_name = config.app_name_en  = queryParams.app_name;
      }
    }
  }
  componentDidMount(){
    //load facebook
    if(facebook_app_id){
      facebook(facebook_app_id,FB => {
        if(facebook_page_id) FB.CustomerChat.show(true)
      });
    }
    //load google recaptcha
    if(GOOGLE_RECAPTCHA_SITE_KEY){
      google(GOOGLE_RECAPTCHA_SITE_KEY,()=>{
      })
    }
  }
  render(){
    return (
      <HashRouter>
        <App config={config} provider={Provider} notifyProvider={withRouter(NotifyProvider)}/>
        {!!facebook_app_id &&
          <div id="fb-root"></div>
        }
        {(facebook_page_id && facebook_app_id)?
          <div className="fb-customerchat"
            attribution="setup_tool"
            page_id={facebook_page_id}
            theme_color={mainColor}
            logged_in_greeting={facebook_greeting}
            logged_out_greeting={facebook_greeting}>
          </div>
          :
        null}
        <PwaInstallPromptLoader/>
      </HashRouter>
    )
  }
}
// --- XÓA query có key bắt đầu bằng "dialog_" ---
(function cleanDialogQuery() {
  const hash = window.location.hash; // ví dụ: #/voucher/hd3?dialog_123=open&other=true
  const [path, queryString] = hash.split('?');

  if (!queryString) return;

  const params = new URLSearchParams(queryString);
  let changed = false;

  // Xóa tất cả param bắt đầu bằng dialog_
  for (const key of Array.from(params.keys())) {
    if (key.startsWith('dialog_')) {
      params.delete(key);
      changed = true;
    }
  }

  // Nếu có thay đổi, cập nhật lại URL (không reload)
  if (changed) {
    const newHash = params.toString() ? `${path}?${params.toString()}` : path;
    window.history.replaceState(null, '', window.location.pathname + window.location.search + newHash);
  }
})();
//Khởi tạo app
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<ClientApp />);